export enum RejectionType {
	FOR_NEED = 'for-need',
	GLOBAL_NOT_DELEGABLE = 'global-not-delegable',
}

export interface RejectProfileWorker {
	workerId: string;
	fromJobOffer?: boolean;
}

export interface RejectProfilesForNeedData {
	workers: RejectProfileWorker[];
	rejectionReasonId: string;
	rejectionComment: string;
}

export interface BulkWorkerActionResult {
	successCount: number;
	failedCount: number;
	successWorkerIds: string[];
	failedWorkerIds: string[];
}

export interface RejectProfileForNeedResponse {
	besoinId: string;
	rejectedCount: number;
}

export interface RejectReason {
	id: string;
	label: string;
	requiresComment?: boolean;
}

export interface RejectionSuccessPayload {
	successCount: number;
	rejectionType: RejectionType;
	reasonId: string;
	reasonLabel: string;
	comment: string;
}

export interface RejectProfileWorkerModalProps {
	includeCompanyNeedRejection?: boolean;
	isMissionProposed?: boolean;
	open: boolean;
	workersIds: string[];
	workerName?: string;
	companyNeedId: string;
	fromJobOffer?: boolean;
	canSetNonDelegable?: boolean;
	onSuccess?: (payload: RejectionSuccessPayload) => void | Promise<void>;
	onRemoveFromAgency?: (workerIds: string[]) => void | Promise<void>;
}
